/**
 * Running JS `package.json` semver (`__APP_VERSION__`) for `x-player-embedded-version`.
 * Tiny module so Jest can import APIClientService without loading `constants.ts`.
 */
export function getEmbeddedPlayerAppVersion(): string {
  return typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : ''
}
